import React from 'react';

interface DetailFieldProps {
  label: React.ReactNode;
  value: React.ReactNode;
}

/**
 * Paire label/valeur d'une fiche de détail (`dt`/`dd`), à utiliser à l'intérieur
 * d'un `<dl>`. Le wrapping dans un `<div>` est autorisé par la spec HTML5 pour
 * grouper les paires `dt`/`dd` (utile pour une mise en page en grille).
 */
const DetailField: React.FC<DetailFieldProps> = ({ label, value }) => (
  <div>
    <dt className="text-gray-500 mb-0.5">{label}</dt>
    <dd className="font-medium text-gray-900">{value}</dd>
  </div>
);

export default DetailField;
